import { $api } from "@/shared/api";

import { LOGIN_PAGE, leavePage } from "../lib/leavePage";

// Выход: `POST /api/auth/logout`, затем полный переход на страницу входа.
// Перезагрузка сбрасывает кэш Query и закрывает соединение Centrifugo.
// 401 значит, что сессии уже нет, — это тоже выход.
export const useLogout = () =>
  $api.useMutation("post", "/api/auth/logout", {
    onSuccess: () => {
      leavePage(LOGIN_PAGE);
    },
    onError: (error) => {
      if (error.status === 401) {
        leavePage(LOGIN_PAGE);
      }
    },
  });
